import { Checkbox, CheckboxProps } from 'antd'
import './styles.css'
import { CSSProperties } from 'react'

interface IProps extends CheckboxProps {
    label: string
    styleLabel?: CSSProperties
}
export const Check = ({ label, styleLabel, ...props }: IProps) => {
    return (
        <Checkbox className='custom-checkbox' {...props}>
            {styleLabel ? <p style={styleLabel}>{label}</p> : label}
        </Checkbox>
    )
}
